import { Routes } from '@angular/router';
import { MenuRouteGuard } from 'app/core/auth/menu-route.guard';

export const Full_ROUTES: Routes = [
  {
    path: 'servico',
    canActivate: [MenuRouteGuard],
    loadChildren: () => import('../../features/servico/servico.routes').then(m => m.ROUTES),
    data: {
      breadcrumbs: true,
      text: 'Serviço'           
    }
  },
  {
    path: 'vincular-usuario',
    canActivate: [MenuRouteGuard],
    loadChildren: () => import('../../features/vincular-usuario/vincular-usuario.routes').then(m => m.ROUTES),
    data: {
      breadcrumbs: true,
      text: 'Usuário'
    }    
  },
  {
    path: 'vincular-menu',
    canActivate: [MenuRouteGuard],
    loadChildren: () => import('../../features/vincular-menu/vincular-menu.routes').then(m => m.ROUTES),
    data: {
      breadcrumbs: true,
      text: 'Menu'
    }
  },
  {
    path: 'vincular-endpoint',
    canActivate: [MenuRouteGuard],
    loadChildren: () => import('../../features/vincular-endpoint/vincular-endpoint.routes').then(m => m.ROUTES),
    data: {
      breadcrumbs: true,
      text: 'Endpoint'
    }
  },
  {
    path: 'vincular-sistema',
    canActivate: [MenuRouteGuard],
    loadChildren: () => import('../../features/vincular-sistema/vincular-sistema.routes').then(m => m.ROUTES),
    data: {
      breadcrumbs: 'Sistema',
      text: 'Sistema'
    }
  },
  {
    path: 'controle-acesso',
    canActivate: [MenuRouteGuard],
    loadChildren: () => import('../../features/controle-acesso/controle-acesso.routes').then(m => m.ROUTES),
    data: {
      breadcrumbs: true,
      text: 'Controle de Acesso'
    }
  },
  {
    // Documentação — o item vem do menu do servidor (objeto MENU, por perfil), mas é FIXADO no rodapé
    // pelo menu-left (bottomNode). Mantém o MenuRouteGuard como os demais itens server-driven.
    path: 'base-conhecimento',
    canActivate: [MenuRouteGuard],
    loadChildren: () => import('../../features/base-conhecimento/base-conhecimento.routes').then(m => m.ROUTES),
    data: {
      breadcrumbs: true,
      text: 'Base de Conhecimento'
    }
  }
];
